import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// Model imports
import { BaseCommunityParameterDto } from '../../community-module/_models/base-community-parameter-dto';
import { BaseOwnerParametersDto } from '../../property-module/_models/base-owner-parameters-dto';
import { CommunityAlertResultDto } from '../_models/community-alert-result-dto';
import { OwnerAlertResultDto } from '../_models/owner-alert-result-dto';
import { StatusMessageResultDto } from '../../_models/status-message-result-dto';
// Constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class AlertsService {
    constructor(httpClient, cachingService) {
        this.httpClient = httpClient;
        this.cachingService = cachingService;
    }
    getCommunityAlerts(communityId, clearCache = true) {
        const params = new BaseCommunityParameterDto(communityId);
        params.clearCache = clearCache;
        return this.getAlerts(params, URLConstants.ccCommunityApiBaseUrl).pipe(map((results) => plainToClass(CommunityAlertResultDto, results)));
    }
    saveCommunityAlert(params) {
        return this.saveOrUpdateAlert(params, URLConstants.ccCommunityApiBaseUrl, false);
    }
    updateCommunityAlert(params) {
        return this.saveOrUpdateAlert(params, URLConstants.ccCommunityApiBaseUrl, true);
    }
    getOwnerAlerts(customerId, communityId, clearCache = true) {
        const params = new BaseOwnerParametersDto(customerId, communityId);
        params.clearCache = clearCache;
        return this.getAlerts(params, URLConstants.ccOwnerApiBaseUrl).pipe(map((results) => plainToClass(OwnerAlertResultDto, results)));
    }
    saveOwnerAlert(params) {
        return this.saveOrUpdateAlert(params, URLConstants.ccOwnerApiBaseUrl, false);
    }
    updateOwnerAlert(params) {
        return this.saveOrUpdateAlert(params, URLConstants.ccOwnerApiBaseUrl, true);
    }
    getAlerts(params, apiBaseUrl) {
        const url = `${apiBaseUrl}alerts${params.getQueryString()}`;
        this.cachingService.registerForCache(url, params.clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient.get(url, { headers });
    }
    saveOrUpdateAlert(params, apiBaseUrl, isUpdate = false) {
        if (isUpdate) {
            return this.httpClient
                .put(`${apiBaseUrl}alerts`, classToPlain(params))
                .pipe(map((response) => plainToClass(StatusMessageResultDto, response)));
        }
        else {
            return this.httpClient
                .post(`${apiBaseUrl}alerts`, classToPlain(params))
                .pipe(map((response) => plainToClass(StatusMessageResultDto, response)));
        }
    }
}
AlertsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AlertsService_Factory() { return new AlertsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: AlertsService, providedIn: "root" });
